<template>
  <v-footer color="background">
    <v-container>
      <v-row>
        <v-col class="text-center">
          <div class="d-flex justify-center ga-3">
            <a href="https://www.facebook.com/share/g/1BTi2u34Hm/" target="_blank" rel="noopener">
              <v-btn icon="mdi-facebook" density="comfortable" variant="text" color="grey"></v-btn>
            </a>
            <a href="https://x.com/reeflendar" target="_blank" rel="noopener">
              <v-btn icon="mdi-twitter" density="comfortable" variant="text" color="grey"></v-btn>
            </a>
            <a href="https://www.instagram.com/reeflendar/" target="_blank" rel="noopener">
              <v-btn icon="mdi-instagram" density="comfortable" variant="text" color="grey"></v-btn>
            </a>
            <a href="https://www.tiktok.com/@reeflendar" target="_blank" rel="noopener">
              <v-btn density="comfortable" variant="text" color="grey">
                <svg
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 50 50"
                  width="24"
                  height="24"
                  style="vertical-align: middle; margin-top: 6px;"
                >
                  <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
                </svg>
              </v-btn>
            </a>
            <a href="https://discord.gg/sPj7jfebr7" target="_blank" rel="noopener">
              <v-btn icon="mdi-chat" density="comfortable" variant="text" color="grey"></v-btn>
            </a>
            <a href="https://www.youtube.com/@reeflendar" target="_blank" rel="noopener">
              <v-btn icon="mdi-youtube" density="comfortable" variant="text" color="grey"></v-btn>
            </a>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <div class="d-flex justify-center ga-4">
            <a href="/">Home</a>
            <a href="/terms">Terms of Service</a>
            <a href="/privacy">Privacy Policy</a>
            <a href="/about">About</a>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center text-caption">
          <div class="d-flex align-center justify-center" style="gap: 8px;">
            <span>&copy; {{ new Date().getFullYear() }} Reeflendar. All rights reserved.</span>
            <img src="@/assets/footer_zoas.png" style="max-height:32px;" />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>